"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _formatMessage = _interopRequireDefault(require("../format-message"));

require("../rce/languages/hu_HU");

/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
var locale = {
  announcement_list_da155734: {
    message: "Hirdetm\xE9nylista"
  },
  announcements_a4b8ed4a: {
    message: "Hirdetm\xE9nyek"
  },
  assignments_1e02582c: {
    message: "Feladatok"
  },
  background_color_press_down_to_select_ef99fdac: {
    message: "H\xE1tt\xE9rsz\xEDn, nyomja le a kiv\xE1laszt\xE1shoz"
  },
  c_2001_acme_inc_283f7f80: {
    message: "(c) 2001 Acme Inc."
  },
  cancel_file_upload_9903e7b9: {
    message: "Cancel file upload"
  },
  cancel_image_upload_2c771950: {
    message: "Cancel image upload"
  },
  cc_attribution_f6de631f: {
    message: "CC Nevezd meg!"
  },
  cc_attribution_no_derivatives_b006744f: {
    message: "CC Nevezd meg!-Ne v\xE1ltoztasd!"
  },
  cc_attribution_non_commercial_39e0d30d: {
    message: "CC Nevezd meg!-Ne add el!"
  },
  cc_attribution_non_commercial_no_derivatives_9fe74c00: {
    message: "CC Nevezd meg!-Ne add el!-Ne v\xE1ltoztasd!"
  },
  cc_attribution_non_commercial_share_alike_c7edb1e5: {
    message: "CC Nevezd meg!-Ne add el!-\xCDgy add tov\xE1bb!"
  },
  cc_attribution_share_alike_669e7f16: {
    message: "CC Nevezd meg!-\xCDgy add tov\xE1bb!"
  },
  choose_usage_rights_33683854: {
    message: "V\xE1lasszon a felhaszn\xE1l\xF3i jogokb\xF3l..."
  },
  click_any_file_to_insert_a_download_link_for_that__a708fa4c: {
    message: "Let\xF6lt\xE9si link besz\xFAr\xE1s\xE1hoz kattintson az adott f\xE1jlra."
  },
  click_any_image_to_embed_the_image_in_the_page_2cdd1136: {
    message: "Kattintson ide b\xE1rmilyen k\xE9p besz\xFAr\xE1s\xE1hoz az oldalra."
  },
  click_any_page_to_insert_a_link_to_that_page_ac920c02: {
    message: "Az oldalra mutat\xF3 link besz\xFAr\xE1s\xE1hoz kattintson a k\xEDv\xE1nt oldalra."
  },
  click_to_embed_image_33107dd8: {
    message: "Kattintson a be\xE1gyazott k\xE9phez"
  },
  click_to_embed_imagename_c41ea8df: {
    message: "Click to embed { imageName }"
  },
  click_to_insert_a_link_into_the_editor_c19613aa: {
    message: "Click to insert a link into the editor."
  },
  click_to_insert_a_link_to_this_item_39794098: {
    message: "Click to insert a link to this item."
  },
  close_flickr_form_b32e600a: {
    message: "Close Flickr form"
  },
  collaborations_5c56c15f: {
    message: "Egy\xFCttm\u0171k\xF6d\xE9s"
  },
  copyright_holder_66ee111: {
    message: "Jog tulajdonosa:"
  },
  course_navigation_dd035109: {
    message: "Kurzusnavig\xE1ci\xF3"
  },
  creative_commons_license_725584ae: {
    message: "Creative Commons licenc:"
  },
  discussions_a5f96392: {
    message: "F\xF3rumok"
  },
  discussions_index_6c36ced: {
    message: "F\xF3rumok indexe"
  },
  embed_image_1080badc: {
    message: "Be\xE1gyazott k\xE9p"
  },
  enter_search_terms_e397b1f0: {
    message: "keres\u0151szavak megad\xE1sa"
  },
  file_upload_form_4aaad554: {
    message: "File Upload Form"
  },
  files_c300e900: {
    message: "F\xE1jlok"
  },
  files_index_af7c662b: {
    message: "F\xE1jlok indexe"
  },
  folder_705fd2d7: {
    message: "Mappa"
  },
  font_size_press_down_to_select_6c25dc2d: {
    message: "Bet\u0171m\xE9ret, nyomja le a kiv\xE1laszt\xE1shoz"
  },
  formatting_press_down_to_select_df728c30: {
    message: "Form\xE1z\xE1s, nyomja le a kiv\xE1laszt\xE1shoz"
  },
  grades_a61eba0a: {
    message: "\xC9rt\xE9kel\xE9sek"
  },
  group_navigation_99f191a: {
    message: "Csoportnavig\xE1ci\xF3"
  },
  i_have_obtained_permission_to_use_this_file_6386f087: {
    message: "Szereztem jogosults\xE1got ennek a f\xE1jlnak a haszn\xE1lat\xE1hoz."
  },
  i_hold_the_copyright_71ee91b1: {
    message: "Megtartom a szerz\u0151i jogot"
  },
  image_upload_form_7b74079a: {
    message: "Image Upload Form"
  },
  images_7ce26570: {
    message: "K\xE9pek"
  },
  insert_equella_links_49a8dacd: {
    message: "Insert Equella Links"
  },
  insert_link_6dc23cae: {
    message: "Link besz\xFAr\xE1sa"
  },
  insert_math_equation_57c6e767: {
    message: "Matematikai k\xE9plet besz\xFAr\xE1sa"
  },
  link_7262adec: {
    message: "Hivatkoz\xE1s"
  },
  link_to_a_new_page_6c4ad034: {
    message: "Link egy \xFAj oldalra"
  },
  link_to_other_content_in_the_course_879163b5: {
    message: "Linkel\xE9s m\xE1s kurzustartalomhoz."
  },
  link_to_other_content_in_the_group_3fe25379: {
    message: "M\xE1s tartalomhoz kapcsol\xE1s a csoportban."
  },
  links_14b70841: {
    message: "Linkek"
  },
  load_more_results_460f49a9: {
    message: "Load more results"
  },
  loading_25990131: {
    message: "Bet\xF6lt\xE9s..."
  },
  loading_failed_b3524381: {
    message: "Loading failed..."
  },
  modules_c4325335: {
    message: "Modulok"
  },
  no_results_940393cf: {
    message: "No results."
  },
  pages_e5414c2c: {
    message: "Oldalak"
  },
  people_b4ebb13c: {
    message: "R\xE9sztvev\u0151k"
  },
  quizzes_7e598f57: {
    message: "Kv\xEDzek"
  },
  rich_text_area_press_alt_f8_for_help_58f0f2c3: {
    message: "Vizu\xE1lis sz\xF6vegter\xFClet, nyomja le az ALT+F8-at a seg\xEDts\xE9ghez"
  },
  search_280d00bd: {
    message: "Keres\xE9s"
  },
  search_flickr_6884b518: {
    message: "Search Flickr"
  },
  select_a_folder_to_upload_your_file_into_b82d12b: {
    message: "Select a folder to upload your file into"
  },
  syllabus_f191f65b: {
    message: "Tematika"
  },
  text_color_press_down_to_select_8f5ad9b5: {
    message: "Sz\xF6vegsz\xEDn, nyomja le a kiv\xE1laszt\xE1shoz"
  },
  the_material_is_in_the_public_domain_279c39a3: {
    message: "Az anyag a k\xF6zkincs kateg\xF3ri\xE1ba tartozik"
  },
  the_material_is_licensed_under_creative_commons_3242cb5e: {
    message: "Ezt az anyagot Creative Commons licenc alatt tett\xE9k k\xF6zz\xE9."
  },
  the_material_is_subject_to_fair_use_exception_41bc6a4b: {
    message: "Az anyag a m\xE9lt\xE1nyos haszn\xE1lat elve alapj\xE1n k\xE9sz\xFClt"
  },
  upload_8b403d05: {
    message: "Felt\xF6lt\xE9s"
  },
  upload_a_new_file_96e6d4ff: {
    message: "\xDAj f\xE1jl felt\xF6lt\xE9se"
  },
  upload_a_new_image_890df275: {
    message: "\xDAj k\xE9p felt\xF6lt\xE9se"
  },
  usage_right_ff96f3e2: {
    message: "Felhaszn\xE1l\xE1si jog:"
  },
  what_would_you_like_to_call_the_new_page_d7e4488a: {
    message: "Mi legyen az \xFAj oldal neve?"
  },
  wiki_home_9cd54d0: {
    message: "Wiki kezd\u0151lap"
  }
};

_formatMessage.default.addLocale({
  hu: locale
});